export default "__VITE_ASSET__Bx906nF___"